/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Row, Col} from "react-bootstrap";


import ContentInformationComponent from "@Components/UI/Content/Information";


import MonitoryNoteListElementComponent from "@UIPages/Authenticated/MonitoryNotes/MonitoryNotesList/MonitoryNote";


import MONITORY_NOTE_INTERFACE from "@Services/Application/Interfaces/MonitoryNotes/MonitoryNote";


type MonitoryNotesListProps = {
    MONITORY_NOTES: MONITORY_NOTE_INTERFACE[];
    MONITORY_NOTES_LIST_TYPE?: "LIST" | "HOME";
};


export const MonitoryNotesListComponent: React.FC<MonitoryNotesListProps> = ({
    MONITORY_NOTES,
    MONITORY_NOTES_LIST_TYPE = "LIST"
}) : JSX.Element | null => {


    if (!MONITORY_NOTES) return null;


    MONITORY_NOTES?.sort((
        monitoryNote1: MONITORY_NOTE_INTERFACE,
        monitoryNote2: MONITORY_NOTE_INTERFACE
    ) =>
        new Date(monitoryNote1?.ProcessStartDate || "")
        >
        new Date(monitoryNote2?.ProcessStartDate || "") ? 1 : -1
    );


    let MONITORY_NOTES_LIST_MESSAGE = "Nie masz żadnych Awizacji";

    if (MONITORY_NOTES_LIST_TYPE === "HOME") {
        MONITORY_NOTES_LIST_MESSAGE = `Nie masz na dziś żadnych Awizacji`;
    }


    const MONITORY_NOTES_LIST = MONITORY_NOTES.map((MONITORY_NOTE, i: number) =>
        <MonitoryNoteListElementComponent
            key={i}
            MONITORY_NOTE={MONITORY_NOTE}
            MONITORY_NOTE_LIST_TYPE={MONITORY_NOTES_LIST_TYPE}
            FIRST={i === 0}
        />
    );


    return (
        <Col xs={12} className={"monitory-notes-list-component monitory-notes-list"}>
            <Row className={"monitory-notes-list-content"}>

                {MONITORY_NOTES?.length > 0 ?

                MONITORY_NOTES_LIST

                :

                <ContentInformationComponent
                    contentMessage={MONITORY_NOTES_LIST_MESSAGE}
                    cssClasses={`monitory-notes-list-message`}
                />

                }

            </Row>
        </Col>
    );

};


export default MonitoryNotesListComponent;
